export enum AgencyType {
  ACCREDITATION = 'ACCREDITATION',
  REGULATORY = 'REGULATORY',
  CONTRACTUAL = 'CONTRACTUAL',
  INTERNAL = 'INTERNAL',
}
